// A genuinely 0%-wide bar segment with a gradient/solid background is not
// just visually invisible — html2canvas throws trying to rasterize a
// gradient fill on a 0×0 element ("canvas element with a width or height of
// 0" from createPattern), which breaks the PNG export of any block
// containing one. A tiny floor keeps every segment paintable without being
// visually different from an actual zero at these bar widths.
const MIN_VISIBLE_BAR_WIDTH_PCT = 0.5

export function safeBarWidthPct(percent: number): number {
  if (!Number.isFinite(percent) || percent <= 0) {
    return MIN_VISIBLE_BAR_WIDTH_PCT
  }

  return Math.max(percent, MIN_VISIBLE_BAR_WIDTH_PCT)
}
